import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/layout/layout'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

// ！！！注意：name需和path最后一个字段保持一致且唯一，用于全局保存权限列表
// 不需要使用布局组件，不需要登陆的页面单独写，如下
const otherRouter = [
  {
    path: '/login',
    name: 'login',
    meta: {},
    component: () => import(/* webpackChunkName: "login" */'@/views/login/index.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {},
    component: () => import(/* webpackChunkName: "notice" */'@/views/notice/index.vue')
  },
  {
    path: '/noticeDetails',
    name: 'noticeDetails',
    meta: {},
    component: () => import(/* webpackChunkName: "notice" */'@/views/notice/noticeDetails.vue')
  },
  {
    path: '/resolve',
    name: 'resolve',
    meta: {},
    component: () => import(/* webpackChunkName: "notice" */'@/views/home/resolve.vue')
  },
  {
    path: '/partner',
    name: 'partner',
    meta: {},
    component: () => import(/* webpackChunkName: "home" */'@/views/home/partner.vue')
  },
  {
    path: '/introduction',
    name: 'introduction',
    meta: {},
    component: () => import(/* webpackChunkName: "home" */'@/views/home/introduction.vue')
  },
  {
    path: '/connectUs',
    name: 'connectUs',
    meta: {},
    component: () => import(/* webpackChunkName: "home" */'@/views/home/connectUs.vue')
  },
  {
    path: '/resolvePlan',
    name: 'resolvePlan',
    meta: {},
    component: () => import(/* webpackChunkName: "home" */'@/views/home/resolvePlan.vue')
  },
  {
    path: '/resolveIndustry',
    name: 'resolveIndustry',
    meta: {},
    component: () => import(/* webpackChunkName: "home" */'@/views/home/resolveIndustry.vue')
  },
  {
    path: '/resolveReduce',
    name: 'resolveReduce',
    meta: {},
    component: () => import(/* webpackChunkName: "home" */'@/views/home/resolveReduce.vue')
  }
]
// 使用布局组件且但不出现在侧边栏中的页面
const singleRouter = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'index',
        meta: {
          title: '首页'
        },
        component: () => import(/* webpackChunkName: "index" */'../views/index.vue')
      }
    ]
  },
  {
    path: '/activityDetails',
    component: Layout,
    children: [
      {
        path: '/statistic/activityDetails',
        name: 'activityDetails',
        component: () => import(/* webpackChunkName: "statistic" */'../views/statistic/activityDetails.vue'),
        meta: {
          root: ['activityChart', 'allActivity'],
          title: '活动详情'
        }
      }
    ]
  },
  {
    path: '/subsidyMerchant',
    component: Layout,
    children: [
      {
        path: '/subsidyActivity/subsidyMerchant',
        name: 'subsidyMerchant',
        component: () => import(/* webpackChunkName: "subsidyActivity" */'../views/subsidyActivity/subsidyMerchant.vue'),
        meta: {
          root: ['subsidyActivityManage'],
          title: '商户管理'
        }
      },
      {
        path: '/subsidyActivity/merchantInfo',
        name: 'merchantInfo',
        component: () => import(/* webpackChunkName: "subsidyActivity" */'../views/subsidyActivity/merchantInfo.vue'),
        meta: {
          root: ['subsidyActivityManage'],
          title: '商户信息'
        }
      }
    ]
  },
  {
    path: '/quotaMerchant',
    component: Layout,
    children: [
      {
        path: '/subsidyActivity/quotaMerchant',
        name: 'quotaMerchant',
        component: () => import(/* webpackChunkName: "subsidyActivity" */'../views/subsidyActivity/quotaMerchant.vue'),
        meta: {
          root: ['subsidyActivityManage'],
          title: '额度包管理'
        }
      }
    ]
  },
  {
    path: '/merchantQuotaMoreDetail',
    component: Layout,
    children: [
      {
        path: '/unionReceiptManage/merchantQuotaMoreDetail',
        name: 'merchantQuotaMoreDetail',
        component: () => import(/* webpackChunkName: "merchantQuotaMoreDetail" */'../views/unionReceiptManage/merchantQuotaMoreDetail.vue'),
        meta: {
          root: ['unionReceiptManage'],
          title: '更多详情'
        }
      }
    ]
  }
]
// 使用布局组件且出现在侧边栏中的页面
export const menuRouter = [
  {
    path: '/activityChart',
    component: Layout,
    children: [
      {
        path: '/statistic/activityChart',
        name: 'activityChart',
        meta: {
          title: '卡券活动数据报表'
        },
        component: () => import(/* webpackChunkName: "statistic" */'../views/statistic/activityChart.vue')
      }, {
        path: '/statistic/subsidyDetail',
        name: 'subsidyDetail',
        meta: {
          title: '补贴出款明细'
        },
        component: () => import('../views/statistic/subsidyDetail.vue')
      }, {
        path: '/statistic/activityIndicator',
        name: 'activityIndicator',
        meta: {
          title: '活动指标数据报表'
        },
        component: () => import('../views/statistic/activityIndicator.vue')
      }
    ]
  },
  {
    path: '/allActivity',
    component: Layout,
    children: [
      {
        path: '/statistic/allActivity',
        name: 'allActivity',
        meta: {
          title: '全部活动'
        },
        component: () => import(/* webpackChunkName: "statistic" */'../views/statistic/allActivity.vue')
      }
    ]
  },
  {
    path: '/activityMerchantT0',
    component: Layout,
    children: [
      {
        path: '/statistic/activityMerchantT0',
        name: 'activityMerchantT0',
        meta: {
          title: '活动商户T0打款数据'
        },
        component: () => import(/* webpackChunkName: "statistic" */'../views/statistic/activityMerchantT0.vue')
      }
    ]
  },
  {
    path: '/activityMerchantT1',
    component: Layout,
    children: [
      {
        path: '/statistic/activityMerchantT1',
        name: 'activityMerchantT1',
        meta: {
          title: '活动商户T1打款数据'
        },
        component: () => import(/* webpackChunkName: "statistic" */'../views/statistic/activityMerchantT1.vue')
      }
    ]
  },
  {
    path: '/activityIndicator',
    component: Layout,
    children: [
      {
        path: '/statistic/activityIndicator',
        name: 'activityIndicator',
        meta: {
          title: '活动指标数据报表'
        },
        component: () => import('../views/statistic/activityIndicator.vue')
      }
    ]
  },
  {
    path: '/automationExport',
    component: Layout,
    children: [
      {
        path: '/statistic/automationExport',
        name: 'automationExport',
        meta: {
          title: '数据导出自动化管理'
        },
        component: () => import('../views/statistic/automationExport.vue')
      }
    ]
  },
  {
    path: '/transactionDetail',
    component: Layout,
    children: [
      {
        path: '/statistic/transactionDetail',
        name: 'transactionDetail',
        meta: {
          title: '交易明细查询'
        },
        component: () => import('../views/statistic/transactionDetail/index.vue')
      }
    ]
  },
  {
    path: '/userManage',
    component: Layout,
    children: [
      {
        path: '/rootManage/userManage',
        name: 'userManage',
        meta: {
          title: '用户管理'
        },
        component: () => import(/* webpackChunkName: "rootManage" */'../views/rootManage/userManage.vue')
      }
    ]
  },
  {
    path: '/roleManage',
    component: Layout,
    children: [
      {
        path: '/rootManage/roleManage',
        name: 'roleManage',
        meta: {
          title: '角色管理'
        },
        component: () => import(/* webpackChunkName: "rootManage" */'../views/rootManage/roleManage.vue')
      }
    ]
  },
  {
    path: '/activityManage',
    component: Layout,
    children: [
      {
        path: '/activity/activityManage',
        name: 'activityManage',
        meta: {
          title: '卡券活动管理'
        },
        component: () => import(/* webpackChunkName: "activity" */'../views/activity/activityManage.vue')
      }
    ]
  },
  {
    path: '/miniAuthAccount',
    component: Layout,
    children: [
      {
        path: '/rootManage/miniAuthAccount',
        name: 'miniAuthAccount',
        meta: {
          title: '小程序账号审核'
        },
        component: () => import(/* webpackChunkName: "rootManage" */'../views/rootManage/miniAuthAccount.vue')
      }
    ]
  },
  {
    path: '/resourceManage',
    component: Layout,
    children: [
      {
        path: '/rootManage/resourceManage',
        name: 'resourceManage',
        meta: {
          title: '资源管理'
        },
        component: () => import(/* webpackChunkName: "rootManage" */'../views/rootManage/resourceManage.vue')
      }
    ]
  },
  {
    path: '/bankManage',
    component: Layout,
    children: [
      {
        path: '/customerManage/bankManage',
        name: 'bankManage',
        meta: {
          title: '银行管理'
        },
        component: () => import(/* webpackChunkName: "rootManage" */'../views/customerManage/bankManage.vue')
      }
    ]
  },
  {
    path: '/customerManagerManage',
    component: Layout,
    children: [
      {
        path: '/customerManage/customerManagerManage',
        name: 'customerManagerManage',
        meta: {
          title: '银行经理管理'
        },
        component: () => import(/* webpackChunkName: "rootManage" */'../views/customerManage/customerManagerManage')
      }
    ]
  },
  {
    path: '/subsidyActivityManage',
    component: Layout,
    children: [
      {
        path: '/subsidyActivity/subsidyActivityManage',
        name: 'subsidyActivityManage',
        meta: {
          title: '活动管理'
        },
        component: () => import(/* webpackChunkName: "subsidyActivity" */'../views/subsidyActivity/subsidyActivityManage.vue')
      }
    ]
  },
  {
    path: '/openCardAssignmentRecords',
    component: Layout,
    children: [
      {
        path: '/subsidyActivity/openCardAssignmentRecords',
        name: 'openCardAssignmentRecords',
        meta: {
          title: '开卡指派记录'
        },
        component: () => import(/* webpackChunkName: "subsidyActivity" */'../views/subsidyActivity/openCardAssignmentRecords.vue')
      }
    ]
  },
  {
    path: '/downloadCenter',
    component: Layout,
    children: [
      {
        path: '/fileManage/downloadCenter',
        name: 'downloadCenter',
        meta: {
          title: '下载中心'
        },
        component: () => import(/* webpackChunkName: "fileManage" */'../views/fileManage/downloadCenter.vue')
      }
    ]
  },
  {
    path: '/customExportCenter',
    component: Layout,
    children: [
      {
        path: '/fileManage/customExportCenter',
        name: 'customExportCenter',
        meta: {
          title: '自定义导出功能'
        },
        component: () => import(/* webpackChunkName: "fileManage" */'../views/fileManage/customExportCenter.vue')
      }
    ]
  },
  {
    path: '/exportTemplateDetail',
    component: Layout,
    children: [
      {
        path: '/fileManage/exportTemplateDetail',
        name: 'exportTemplateDetail',
        meta: {
          title: '详情'
        },
        component: () => import(/* webpackChunkName: "fileManage" */'../views/fileManage/exportTemplateDetail.vue')
      }
    ]
  },
  {
    path: '/bankRecommendManage',
    component: Layout,
    children: [
      {
        path: '/unionReceiptManage/bankRecommendManage',
        name: 'bankRecommendManage',
        meta: {
          title: '银行推荐商户管理'
        },
        component: () => import(/* webpackChunkName: "unionReceiptManage" */'../views/unionReceiptManage/bankRecommendManage.vue')
      }
    ]
  },
  {
    path: '/merchantRecord',
    component: Layout,
    children: [
      {
        path: '/unionReceiptManage/merchantRecord',
        name: 'merchantRecord',
        meta: {
          title: '实时返报名商户记录'
        },
        component: () => import('../views/unionReceiptManage/merchantRecord.vue')
      }
    ]
  },
  {
    path: '/uniteMerchantManage',
    component: Layout,
    children: [
      {
        path: '/unionReceiptManage/uniteMerchantManage',
        name: 'uniteMerchantManage',
        meta: {
          title: '联拓商户'
        },
        component: () => import('../views/unionReceiptManage/uniteMerchantManage.vue')
      }
    ]
  },
  {
    path: '/merchantQuotaDetail',
    component: Layout,
    children: [
      {
        path: '/unionReceiptManage/merchantQuotaDetail',
        name: 'merchantQuotaDetail',
        meta: {
          title: '商户额度包配置详情'
        },
        component: () => import('../views/unionReceiptManage/merchantQuotaDetail.vue')
      }
    ]
  },
  {
    path: '/merchantImportRecord',
    component: Layout,
    children: [
      {
        path: '/unionReceiptManage/merchantImportRecord',
        name: 'merchantImportRecord',
        meta: {
          title: '无额度商户记录'
        },
        component: () => import('../views/unionReceiptManage/merchantImportRecord.vue')
      }
    ]
  },
  {
    path: '/merchantOpen',
    component: Layout,
    children: [
      {
        path: '/openManage/merchantOpen',
        name: 'merchantOpen',
        meta: {
          title: '商户开卡'
        },
        component: () => import(/* webpackChunkName: "openManage" */'../views/openManage/merchantOpen.vue')
      }
    ]
  },
  {
    path: '/activitySign',
    component: Layout,
    children: [
      {
        path: '/activityExtension/activitySign',
        name: 'activitySign',
        meta: {
          title: '活动报名'
        },
        component: () => import('../views/activityExtension/activitySign.vue')
      }
    ]
  },
  {
    path: '/operateRecord',
    component: Layout,
    children: [
      {
        path: '/rootManage/operateRecord',
        name: 'operateRecord',
        meta: {
          title: '操作日志'
        },
        component: () => import('../views/rootManage/operateRecord.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes: [
    ...otherRouter,
    ...menuRouter,
    ...singleRouter
  ]
})
export { otherRouter, singleRouter, router }
